<template>
    <div>
        <vs-row>
            <vs-col vs-align="left" vs-w="6">
                <vs-button
                    id="addResource"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="showFormCreate"
                >
                    Ajouter une nouvelle campagne
                </vs-button>

                <DialogPrompt
                    :active.sync="showPopup"
                    :title="getDataPrompt.title"
                    cancel-text="Annuler"
                    accept-text="Enregistrer"
                    :button-accept="getDataPrompt.btnAccept"
                    :is-valid="!formError"
                    @cancel="resetResource"
                    @close="resetResource"
                    @accept="saveResource"
                >
                     <CampaignForm
                        v-model="resource"
                        @error="setFormError"
                    />
                </DialogPrompt>

            </vs-col>
            <vs-col vs-type="flex" vs-align="left" vs-w="6" />
        </vs-row>

        <vs-table
            :sst="true"
            @search="eventSearchItems"
            @sort="eventSortByCol"
            search
            :no-data-text="loading ? `Chargement de vos données...` : `Aucune donnée à afficher`"
            style="width:100%"
            :data="itemsData"
            :loading="true"

            >
            <template slot="header">
                <vs-radio
                    v-model="filter"
                    vs-name="filterList"
                    id="radio-filter-evaluations"
                    class="ml-2"
                    :vs-value="filterValues.EVALUATIONS"
                    @change="setDefaultHandle(filterValues.EVALUATIONS)"
                >
                    Evaluation des enseignements et des formations
                </vs-radio>
                <vs-radio
                    v-model="filter"
                    vs-name="filterList"
                    id="radio-filter-enquetes"
                    class="ml-2"
                    :vs-value="filterValues.ENQUETES"
                    @change="setDefaultHandle(filterValues.ENQUETES)"
                >
                    Enquête interne
                </vs-radio>
                <div class="min-w-10"></div>
                <vs-checkbox class="float-right" id="archived" name="archived" v-model="archived">
                    Afficher les campagnes archivées
                </vs-checkbox>
                <slot />
            </template>
            <template slot="thead">
                <vs-th>
                    <Sort name="title" @sort="eventSortByCol">Libellé</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="start_date" @sort="eventSortByCol">Période</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="services.establishment,name" @sort="eventSortByCol">Établissements</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="services,title" @sort="eventSortByCol">Service</Sort>
                </vs-th>
                <vs-th>Etat des réponses</vs-th>
                <vs-th>
                    <Sort name="status" @sort="eventSortByCol">Statut</Sort>
                </vs-th>
                <vs-th></vs-th>
            </template>

            <template>
                <vs-tr v-for="(item, i) in items.data" :key="i">
                    <vs-td>
                        {{ get(item, ':title') }}
                    </vs-td>
                    <vs-td>
                        {{ get(item, ':start_date') | date }} -> {{ get(item, ':end_date') | date }}
                    </vs-td>
                    <vs-td>
                        {{ arrayUnique(get(item, ':services').map(s => s.establishment.name)).join(', ') }}
                    </vs-td>
                    <vs-td>
                        {{ arrayUnique(get(item, ':services').map(s => s.title)).join(', ') }}
                    </vs-td>
                    <vs-td>
                        {{ get(item, ':ratings_count') || 0 }}/{{ get(item, ':affected_users_count') || 0 }} <i class="fa fa-circle-info ml-1" style="color:navy"></i>
                    </vs-td>
                    <vs-td>
                        <vs-chip color="primary">
                            <span style="cursor: pointer !important; min-height: 26px;min-width: 26px; padding-top: 6px;">
                                {{ get(item, ':status') === 1 ? 'Validé' : 'En cours' }}
                            </span>
                        </vs-chip>
                    </vs-td>
                    <vs-td class="action">
                        <div class="action-wrapper">
                            <vs-button
                                v-if="can('update', 'campaigns', item.id)"
                                :id="'modifyCampaign_' + i"
                                v-tooltip="'Modifier'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-edit"
                                @click.stop="showFormUpdate(item)"
                            />

                            <vs-button
                                v-if="can('read', 'campaigns', item.id)"
                                :id="'showCampaign_' + i"
                                v-tooltip="'Consulter'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-list"
                                @click="showResource(item)"
                            />

                            <vs-button
                                v-if="can('update', 'campaigns', item.id)"
                                :id="'completeCampaign_' + i"
                                v-tooltip="'Compléter'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-plus-square"
                                @click="completeResource(item)"
                            />

                            <vs-button
                                v-if="can('update', 'campaigns', item.id)"
                                :id="'validateCampaign_' + i"
                                v-tooltip="'Valider'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-check-square"
                                @click="validateResource(item)"
                            />

                            <vs-button
                                v-if="can('create', 'campaigns', item.id)"
                                :id="'duplicateCampaign_' + i"
                                v-tooltip="'Dupliquer'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-copy"
                                @click="duplicateResource(item)"
                            />

                            <vs-button
                                v-if="can('delete', 'campaigns', item.id)"
                                :id="'deleteCampaign_' + i"
                                v-tooltip="'Supprimer'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-trash"
                                @click.stop="removeResource(item)"
                            />
                        </div>
                    </vs-td>

                    <template class="flex" slot="expand">
                        <div class="text-left">
                            <a @click="download(item.id, 'v0')" style="cursor:pointer; margin-right: 10px;">Version de synthèse v0.pdf</a>
                            <a @click="download(item.id, 'v1')" style="cursor:pointer; margin-right: 10px;">Version de synthèse v1.pdf</a>
                            <a @click="download(item.id, 'v2')" style="cursor:pointer; margin-right: 10px;">Version de synthèse v2.pdf</a>
                            <a @click="download(item.id, 'raw')" style="cursor:pointer; margin-right: 10px;">Données brutes.xlsx anonymes</a>
                            <a v-if="!item.type.anonymous" @click="download(item.id, 'raw_with_names')" style="cursor:pointer; margin-right: 10px;">Données brutes.xlsx nominatives</a>
                        </div>
                    </template>
                </vs-tr>
            </template>

        </vs-table>

        <vs-row>
            <vs-col class="mt-4" v-if="items.total > 0">
                <vs-pagination :total="Math.ceil(items.total / apiParams.perpage)" v-model="currentPage"></vs-pagination>
            </vs-col>
        </vs-row>
    </div>

</template>

<script>

import CampaignForm from './CampaignForm.vue'
import contentDisposition from "content-disposition"

export default {
    name: 'Campaigns',
    components: {
        CampaignForm
    },
    props: {
        api: {
            type: String
        },
        perpage: {
            type: String
        }
    },
    data() {
        return {
            log: console.log,
            config: [],
            currentPage: 1,
            loading: false,
            showPopup: false,
            isFormCreation: true,
            resource: {
                title: null,
                type_id: null,
                rating_questionnaire_id : null,
                campaign_questionnaire_id : null,
                campaign_field_id : null,
                start_date : null,
                end_date : null,
                sent_date_1 : null,
                sent_date_2 : null,
                sent_date_3 : null,
            },
            formError: true,
            formType: "create",
            prompt: {
                show: {
                    title: 'Consulter une campagne',
                    btnAccept: 'false'
                },
                create: {
                    title: 'Ajouter une campagne',
                    btnAccept: 'filled'
                },
                update: {
                    title: 'Modifier une campagne existante',
                    btnAccept: 'filled'
                }
            },
            filter: null,
            filterValues: {
                EVALUATIONS: 1,
                ENQUETES: 2
            },
            archived: false,
        }
    },

    watch: {
        loading(value) {
            if (value) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        }
    },

    computed: {
        getDataPrompt() {
            switch(this.formType) {
                case 'show':
                    return this.prompt.show
                    break;
                case 'create':
                    return this.prompt.create
                    break;
                case 'update':
                    return this.prompt.update
                    break;
                default:
                    return this.prompt.show
            }
        },
    },

    methods: {

        showFormCreate() {
            this.resetResource();
            this.formType = "create";
            this.showPopup = true
        },

        showFormUpdate(resource) {
            this.setResource(resource);
            this.formType = "update";
            this.showPopup = true
        },

        showResource(resource) {
            this.resourceReadonly = true;
            this.resetResource();
            this.setResource(resource);
            this.formType = 'show';
            this.showPopup = true;
        },


        saveResource() {
            let data = JSON.parse(JSON.stringify(this.resource));
            data.start_date = this.getDate(data.start_date)
            data.end_date = this.getDate(data.end_date)
            data.sent_date_1 = data.sent_date_1 ? data.sent_date_1+' '+data.sent_hour_1+':00:00' : data.sent_date_1
            data.sent_date_2 = data.sent_date_2 ? data.sent_date_2+' '+data.sent_hour_2+':00:00' : data.sent_date_2
            data.sent_date_3 = data.sent_date_3 ? data.sent_date_3+' '+data.sent_hour_3+':00:00' : data.sent_date_3
            if (data.id) {
                this.apiUpdate(data, data.id,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true
                );
            } else {
                this.apiCreate(data,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true
                );
            }
        },

        duplicateResource(resource) {
            this.resourceReadonly = false;
            this.resetResource();
            this.setResource(resource);
            this.resource.id = null;

            this.formType = 'create';
            this.showPopup = true;
        },

        validateResource(resource) {
            console.log('Resource à valider:', resource);
            document.location.href = 'campaigns/evaluate/'+resource.id;
        },

        completeResource(resource) {
            console.log('Resource à compléter:', resource);
            document.location.href = 'campaigns/evaluate/'+resource.id;
        },

        removeResource(resource) {
            this.apiDelete(resource.id, () => this.loadItems());
        },

        setResource(data) {
            let dataTemp = JSON.parse(JSON.stringify(data));
            dataTemp.start_date = dataTemp.start_date ? this.getDate(dataTemp.start_date) : dataTemp.start_date;
            dataTemp.end_date = dataTemp.end_date ? this.getDate(dataTemp.end_date) : dataTemp.end_date;

            dataTemp.sent_hour_1 = dataTemp.sent_date_1 ? this.getHour(dataTemp.sent_date_1) : 8;
            dataTemp.sent_hour_2 = dataTemp.sent_date_2 ? this.getHour(dataTemp.sent_date_2) : 8;
            dataTemp.sent_hour_3 = dataTemp.sent_date_3 ? this.getHour(dataTemp.sent_date_3) : 8;

            dataTemp.sent_date_1 = dataTemp.sent_date_1 ? this.getDate(dataTemp.sent_date_1) : dataTemp.sent_date_1;
            dataTemp.sent_date_2 = dataTemp.sent_date_2 ? this.getDate(dataTemp.sent_date_2) : dataTemp.sent_date_2;
            dataTemp.sent_date_3 = dataTemp.sent_date_3 ? this.getDate(dataTemp.sent_date_3) : dataTemp.sent_date_3;

            this.resource = {...dataTemp};
        },

        resetResource() {
            this.resource = {
                title: null,
                type_id: null,
                rating_questionnaire_id : null,
                campaign_questionnaire_id : null,
                campaign_field_id : null,
                start_date : null,
                end_date : null,
                sent_date_1 : null,
                sent_date_2 : null,
                sent_date_3 : null,
                sent_hour_1 : null,
                sent_hour_2 : null,
                sent_hour_3 : null,
                users: null,
                services: null,
                contribution_services: null,
                validation_services: null,
                blocs: null,
            }
        },

        setFormError (value) {
            this.formError = value;
        },

        setDefaultHandle(filter) {
            this.apiParams.filter = 'type.id|=|'+filter;
            this.loadItems();
        },

        download(campaignId, type) {
            window.axios({
                method: "get",
                url: this.api+'/export/'+campaignId+'/'+type,
                responseType: 'arraybuffer'
            }).then((response) => {
                const disposition = contentDisposition.parse(
                    response.headers["content-disposition"]
                );
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", disposition.parameters.filename);
                document.body.appendChild(link);
                link.click();
            })
        }
    },
    created() {
        this.apiParams.include = [
            'type',
            'rating_questionnaire',
            'campaign_questionnaire',
            'campaign_field',
            'users',
            'services.establishment',
            'services.users',
            'contribution_services',
            'validation_services',
            'blocs',
        ];
        this.apiParams.append = ['affected_users_count'];
        this.apiParams.withCount = 'ratings';
        this.loadItems();
    }
}
</script>
